export default "__VITE_ASSET__CD3rR$bZ__"